import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-video-bg",
  "use": "icon-video-bg-usage",
  "viewBox": "0 0 1152 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1152 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-video-bg\"><defs><style type=\"text/css\"></style></defs><path d=\"M672.4 128H95.6C42.8 128 0 170.8 0 223.6v576.8C0 853.2 42.8 896 95.6 896h576.8c52.8 0 95.6-42.8 95.6-95.6V223.6c0-52.8-42.8-95.6-95.6-95.6z m378.8 75.4L832 354.6v314.8l219.2 151c42.4 29.2 100.8-0.6 100.8-51.6V255c0-50.8-58.2-80.8-100.8-51.6z\" fill=\"\" p-id=\"3109\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol